import { useState, useEffect } from 'react';
import { getSecondsTo } from '@shoflo/polymer';
import { StudioLogger } from '@studio/logger/StudioLogger';
import {
  delayedFunction,
  getStreamButtonState,
  streamAvailable,
  streamButtonStates
} from 'hooks/useStreamButtonState/utils';

const logger = new StudioLogger('useDelayedStreamButtonState');

function useDelayedStreamButtonState({
  streamEndpoints,
  startOn,
  endOn,
  isStreamStopping
}) {
  const maxStartTimeTrigger = 86400; //no delayedFunctions will be triggered more than 24 hours prior to the start time
  const streamButtonState = getStreamButtonState(
    streamEndpoints,
    startOn,
    endOn,
    isStreamStopping
  );
  const [currentStreamButtonState, setCurrentStreamButtonState] =
    useState(streamButtonState);

  useEffect(() => {
    const hasEndpoints = streamAvailable(streamEndpoints, startOn, endOn);
    const broadcastStartMinus90 = getSecondsTo(startOn - 60 * 90 * 1000);

    // Log the stream state change and relevant attributes
    if (currentStreamButtonState !== streamButtonState) {
      logger.info(`Stream button state changed to ${streamButtonState}`, {
        state: streamButtonState,
        streamEndpoints,
        startOn,
        endOn,
        isStreamStopping
      });
    }

    setCurrentStreamButtonState(streamButtonState);

    let timerId = 0;

    if (hasEndpoints && broadcastStartMinus90 <= maxStartTimeTrigger) {
      timerId = delayedFunction(
        setCurrentStreamButtonState,
        broadcastStartMinus90,
        streamButtonStates.NOT_STARTED_ENABLED
      );
    }

    return () => {
      if (timerId > 0) {
        clearTimeout(timerId);
      }
    };
  }, [streamButtonState, endOn, startOn, streamEndpoints]);

  return currentStreamButtonState;
}

export default useDelayedStreamButtonState;
